import { render } from "./fldNumber.vue?vue&type=template&id=5598fa10"
import script from "./fldNumber.vue?vue&type=script&lang=js"
export * from "./fldNumber.vue?vue&type=script&lang=js"

import "./fldNumber.vue?vue&type=style&index=0&id=5598fa10&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QField,QColor});
